/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "rbx";
// import { useApolloClient } from "react-apollo";
// import { debounce } from "lodash";
// import { clearFilterState, getFilterState, uuidGenerator } from "../../utils";

import Copyright from "../Copyright";

import { useCurrentUserRoles } from "../Authorization";
import { useCurrentUser, useSystemCodes } from "../../utils/hooks";

const NestedMenu = ({
  isActive,
  activeMenus,
  toggleMenus,
  name,
  links,
  depth
}) => {
  const roles = useCurrentUserRoles();
  // const client = useApolloClient();
  const { data: user } = useCurrentUser();
  const { data: invoiceSystemCodes } = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus",
    CodeId_in: ["INV", "EXA", "IPA"]
  });
  const { data: billedSystemCodes } = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus",
    CodeId: "BP"
  });

  // if user is pto role only, lets only show them users they are supervisors for
  const shouldQueryBySupervisor = useMemo(
    () =>
      roles.some(role => role === "PTO") &&
      !roles.some(role => role === "ADMIN" || role === "HR"),
    [roles]
  );

  const getItem = (item, id) => {
    // if menu is active show child links
    // we want to have all menus active by default so we invert
    if (!activeMenus[id] && item.links) {
      return (
        <div key={id}>
          <div
            className="nested-menu-item is-active"
            role="button"
            tabIndex="0"
            onClick={() => toggleMenus(id)}
            onKeyDown={e => console.log(e.keyCode)}
          >
            <span>{item.name}</span>
            <Icon size="small">
              <FontAwesomeIcon icon="chevron-up" />
            </Icon>
          </div>
          <NestedMenu
            activeMenus={activeMenus}
            depth={depth + 1}
            links={item.links}
            name={item.name}
            toggleMenus={toggleMenus}
          />
        </div>
      );
    }

    if (item.to) {
      return (
        <Link
          className="nested-menu-item"
          key={id}
          to={item.to}
          onClick={() => toggleMenus(id)}
        >
          <span>{item.name}</span>
        </Link>
      );
    }
    if (item.href) {
      return (
        <a
          className="nested-menu-item"
          href={
            typeof item.href === "function"
              ? item.href({
                  user,
                  invoiceSystemCodes,
                  billedSystemCodes,
                  supervisorRecIdRef: shouldQueryBySupervisor
                    ? user.EmployeeRecIdRef
                    : 0
                })
              : item.href
          }
          key={id}
          rel="noopener noreferrer"
          target="_blank"
          onClick={() => toggleMenus(id)}
        >
          <span>{item.name}</span>
        </a>
      );
    }

    return (
      <a
        className="nested-menu-item"
        key={`${item.name}-${depth}`}
        onClick={() => toggleMenus(id)}
      >
        <span>{item.name}</span>
        <Icon size="small">
          <FontAwesomeIcon icon="chevron-down" />
        </Icon>
      </a>
    );
  };

  const items = links
    .filter(
      link =>
        !Array.isArray(link.permissions) ||
        link.permissions.some(perm => roles.some(x => perm === x))
    )
    .map((child, i) => getItem(child, `${name}-${i}-${depth}`));

  if (depth === 0) {
    return (
      <div
        className={`nested-menu${isActive ? " is-active" : ""}`}
        // key={uuidGenerator()}
        key={`nested-menu-${depth}`}
      >
        <div className="nested-menu-main">
          <div className="nested-menu-title">{name}</div>
          <div className="nested-menu-container">{items}</div>
        </div>
        <div className="nested-menu-foot">
          <Copyright />
        </div>
      </div>
    );
  }
  return (
    <div
      className={`nested-menu-container deep depth-${depth}`}
      // key={uuidGenerator()}
      key={`nested-menu-container-${depth}`}
    >
      {items}
    </div>
  );
};

NestedMenu.propTypes = {
  name: PropTypes.string,
  links: PropTypes.array,
  isActive: PropTypes.bool,
  depth: PropTypes.number,
  activeMenus: PropTypes.object,
  toggleMenus: PropTypes.func
};
NestedMenu.defaultProps = {
  links: [],
  depth: 0
};

export default NestedMenu;
